<div class="modal__header">
  <span class="title">Ошибка при распределении заявок</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appInputCancelX"></div>
</div>
<div class="modal__body">
  <app-message [type]="'error'">
    <div message-content *ngFor="let error of errorsList; let last = last" [ngClass]="{ 'mb-4': !last }">
      <div class="font-weight-bold">Заявка {{ error.ticket_number }}:</div>
      <div *ngFor="let err of error.errors">
        <div>{{ err }}</div>
      </div>
    </div>
  </app-message>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" (click)="activeModal.dismiss()" id="appInputCancelX2">Закрыть</button>
  </div>
</div>
